import { FC, useRef, useEffect, MouseEventHandler, ReactNode } from 'react'
import { CSSTransition } from 'react-transition-group'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { Overlay, Modal } from './styles'

type Props = {
  isOpen?: boolean
  isScrollDisabled?: boolean
  onClose?: () => void
  children?: ReactNode
}

const classNames = {
  appearActive: 'is-visible',
  enterActive: 'is-visible',
  enterDone: 'is-visible',
}

export const MobileSlideModal: FC<Props> = props => {
  const { isOpen, onClose, children, isScrollDisabled } = props

  const overlayRef = useRef<HTMLDivElement>(null)
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = modalRef.current
    if (!element) return

    const pageScrollTop = window.pageYOffset

    if (isOpen) disableBodyScroll(modalRef.current)

    return () => {
      enableBodyScroll(element)

      if (isOpen) window.scrollTo(0, pageScrollTop)
    }
  }, [isOpen])

  useEffect(() => {
    const element = modalRef.current
    if (!isScrollDisabled || !element) return

    const scrollTop = element.scrollTop
    element.scrollTop = 0
    element.style.overflow = 'hidden'

    return () => {
      element.scrollTop = scrollTop
      element.style.overflow = ''
    }
  }, [isScrollDisabled])

  const handleOverlayClick: MouseEventHandler = e => {
    if (onClose && e.target === overlayRef.current) onClose()
  }

  return (
    <CSSTransition classNames={classNames} in={isOpen} timeout={300} unmountOnExit appear>
      <Overlay ref={overlayRef} onClick={handleOverlayClick}>
        <Modal ref={modalRef}>{children}</Modal>
      </Overlay>
    </CSSTransition>
  )
}
